import { createStyles, makeStyles } from '@material-ui/core';

export default makeStyles(
  () =>
    createStyles({
      tooltip: {},
    }),
  { name: 'Tooltip' }
);
